/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import {
    fork, takeEvery, put, call, take, select, takeLatest,
} from 'redux-saga/effects';
import mbpLogger from 'mbp-logger';
import * as errorActions from '../../../Common/ducks/Error/Error-Actions';
import * as showLoadingMessageActions from '../../../Common/ducks/ShowLoadingMessage/ShowLoadingMessage-Actions';

// TODO: Convert and use actions
import { errorOperations } from '../../../Common/ducks/Error';
import { retrieveCart } from '../../../MfeCheckout/ducks/Cart/ducks/RetrieveCart/RetrieveCart-Operations';

import * as formActions from './RecipientForm-Actions';
import { recipientFormFields } from './RecipientForm-Helpers';
import { shippingInfoActions } from '../ShippingInfo';
import { billingAddressCheckSameAsDeliveryAddress, billingAddressIsFormAutoFilled, updateBillingAddressForm } from '../../../MfeCheckout/ducks/Payment/BillingAddress/BillingAddress-Actions';
import { qasAddressSearchOperations } from '../../../Common/ducks/AddressSearchQAS';
import * as commonSelectors from '../../../Common/Common-Selectors';
import { pwaDesktopAddGiftMessage, formatFullGifMessage } from '../../../MfeCheckout/ducks/CartItem/GiftMessageForm/GiftMessageForm-Operations';
import { updateWorkingRecipient } from '../../Recipient-Actions';
import { giftMessageFormSelectors } from '../../../MfeCheckout/ducks/CartItem/GiftMessageForm';
import { getInternationalCountryField, checkIsInternational, getCountryField } from '../../../Checkout/ducks/Checkout/Checkout-Helper';
import { addCardIsleToCart } from '../CardIsle/CardIsle-Operations';
import { resetCardIsle } from '../CardIsle/CardIsle-Actions';
import { resetGiftMessageForm } from '../../../MfeCheckout/ducks/CartItem/GiftMessageForm/GiftMessageForm-Actions';
import { getCardIsleSelected } from '../CardIsle/CardIsle-Selector';

import { callHandleCartFailure } from '../../../MfeCheckout/ducks/Cart/Cart-Actions';
import orderClient from '../../../../../apis/checkout-apis/orderClient';
import cartServiceClient from '../../../../../apis/cart-service-apis/cartServiceClient';
import { checkJWT } from '../../../Member/ducks/Auth/Auth-Operations';
import {
    getGuestAddressBookEntries, getIsAuthenticatedStatus, getOrderId, getProfileInfo,
} from '../../../Member/ducks/Common/Common-Selectors';
import { proccessAddressBookCompleted, saveGuestAddressBook } from '../../../Member/ducks/AddressBook/AddressBook-Actions';

import { getAddressSource } from '../../../App/App-Selectors';
import { getIsWriteScopeCheckout } from '../../../Checkout/ducks/Global/Global-Selectors';
import { prepareRetreiveCart } from '../../../MfeCheckout/ducks/Cart/ducks/RetrieveCart/PrepareRetreiveCart-Operations';
import { getFeatureFlags } from '../../../MfeCheckout/ducks/App/App-Selectors';
import { setSkipValidateCart, triggerValidateOrder, triggerValidateOrderCompleted } from '../../../MfeCheckout/ducks/Cart/ducks/ValidateCart/ValidateCart-Actions';
import { getAddressOneLineString } from '../../../../../app/pages/Checkout/containers/EnterpriseCheckout/Common/Helpers/Input-Helper';
import { getCountryDetailsByThreeDigitCountryCode } from '../../../Checkout/helpers/countryCode';
import { loadAddressBookEntry } from '../../../MfeCheckout/ducks/Member/AddressBookEntry/AddressBookEntry-Actions';

const addRecipient = ({
    jwtToken, orderItemId, recipient, entryId, orderId,
}) => orderClient.addRecipient(
    {},
    jwtToken,
    orderItemId,
    recipient,
    entryId,
    orderId,
);

const getStateCityData = ({
    jwtToken, zipCode,
}) => orderClient.getCityStateFromZip(
    {},
    jwtToken,
    zipCode,
);

const updateRecipientCart = ({
    wcEnv, jwtToken, orderItemId, giftMessage, giftAuthor, occasionCode, orderId, useThisMessageForAll, sympathy,
}) => (
    orderClient.updateCart(
        wcEnv,
        jwtToken,
        orderItemId,
        null,
        null,
        {
            message: giftMessage,
            signature: giftAuthor,
            occasionCode,
            useThisMessageForAll,
        },
        orderId,
        null,
        sympathy,
    )
);

const updateFuneralTime = ({
    wcEnv, jwtToken, orderItemId, orderId, sympathy,
}) => (
    orderClient.updateCart(
        wcEnv,
        jwtToken,
        orderItemId,
        null,
        null,
        null,
        orderId,
        null,
        sympathy,
    )
);

const isCandaZip = (zipcode) => new RegExp(/^[a-zA-Z]{1}[0-9]{1}[a-zA-Z]{1}[- ]{0,1}[0-9]{1}[a-zA-Z]{1}[0-9]{1}/).test(zipcode);

const getFormattedZipCode = (zipCode) => {
    let zipCodeFormatted = zipCode;
    if ((zipCodeFormatted.length === 6 || zipCodeFormatted.length === 7) && isCandaZip(zipCodeFormatted)) {
        const zipSplit = zipCodeFormatted.replace(/\s/gi, '').toUpperCase().split('');
        zipSplit.splice(3, 0, ' ');
        zipCodeFormatted = zipSplit.join('');
    }
    return zipCodeFormatted;
};

function* updateForm(action) {
    try {
        yield put(formActions.updateFormValues(action.data));
    } catch (ex) {
        console.log('EXCEPTION: ', ex);
    }
}

function* updateFormFromAddressBook(action) {
    try {
        yield put(formActions.updateFromAddressBook(action.data));
    } catch (ex) {
        console.log(ex);
    }
}

function* clearFormFields() {
    try {
        yield put(formActions.clearRecipientFormFields());
    } catch (ex) {
        console.log(ex);
    }
}

function* handleProductNotAvailableZipCode() {
    const loggedErrorKeysPayload = yield take(errorActions.loggedErrorKeys().type);
    if (loggedErrorKeysPayload.errorKeys.indexOf('_ERR_NOT_AVALIABLE_IN_ZIP') >= 0) {
        yield call(retrieveCart);
    }
}

const removeMaskForPhoneNumber = (number) => {
    let strNumber = number.toString().trim();
    strNumber = strNumber.replace(/\s/g, '').replace(/[^0-9+]/g, '');
    if (strNumber.indexOf('+') === 0 && strNumber.indexOf('1') === 1) {
        strNumber = strNumber.substring(2, strNumber.length);
    } else if (strNumber.indexOf('+') >= 0) {
        strNumber = strNumber.replace(/\s/g, '').replace(/[^0-9]/g, '');
    }
    return strNumber;
};

function checkIfSavingInternationalProduct(recipientAddress) {
    if (recipientAddress.zipCode === '00000') {
        return true;
    }
    return false;
}

function* submitForm(action) {
    try {
        // Show loader
        yield put(showLoadingMessageActions.updateShowLoadingMessage());

        // Clear Error
        yield put(errorActions.clearErrors({
            errType: 'recipientForm',
            field: `${action.data.orderItemId}_productNotAvailable`,
        }));

        yield put(errorActions.clearErrors({
            errType: 'recipientFormClearAllFields',
            field: 'error',
        }));

        yield put(errorActions.clearErrors({
            errType: 'payment',
            field: action.data.orderItemId,
        }));

        yield put(errorActions.clearErrors({
            errType: 'payment',
            field: `${action.data.orderItemId}_missing_info`,
        }));

        yield put(errorActions.clearErrors({
            errType: 'validateBillingAddress',
        }));

        yield put(errorActions.clearErrors({
            errType: 'payment',
            field: 'orderItemError',
        }));

        // Prepare Save Recipient
        const recipientFormDetails = action.data.recipient;
        if (recipientFormDetails.phone) {
            recipientFormDetails.phone = removeMaskForPhoneNumber(recipientFormDetails.phone);
        }

        if (action.data.useAddressForAll) {
            recipientFormDetails.useAddressForAll = 'Y';
        }

        if (recipientFormDetails.zipCode) {
            recipientFormDetails.zipCode = getFormattedZipCode(recipientFormDetails.zipCode);
        }

        if (action.data.isAddressVerified) recipientFormDetails.isAddressVerified = action.data.isAddressVerified;

        if (action.data.dpvIndicator) recipientFormDetails.dpvIndicator = action.data.dpvIndicator;

        const editingRecipient = yield select(commonSelectors.getCart); // getting current saved recipient address
        const orderItemEditing = editingRecipient?.[0]?.cartItems?.[0] || {};
        const skipAddressBookAdd = ['NBCU', 'DDELVR'].includes(orderItemEditing?.itemInfo?.lineItemType);

        if (skipAddressBookAdd) {
            recipientFormDetails.skipAddressBookAdd = skipAddressBookAdd;
        }

        const jwtToken = yield call(checkJWT);
        const orderId = yield select(commonSelectors.getOrderId);

        // Pass entry Id to update address book
        const reqObj = {
            wcEnv: {},
            jwtToken,
            orderItemId: action.data.orderItemId,
            recipient: recipientFormDetails,
            entryId: action.data.entryId,
            orderId,
        };

        // Save Recipient
        yield call(addRecipient, reqObj);

        const isAuthenticated = yield select(getIsAuthenticatedStatus);
        const isInternational = yield call(checkIfSavingInternationalProduct, recipientFormDetails);

        const isWriteScopeCheckout = yield select(getIsWriteScopeCheckout);
        // Registerd User - Load user addressbook
        if (isAuthenticated && isWriteScopeCheckout) {
            yield put(loadAddressBookEntry());
        }

        // Avoid saving recipient address to guest address book if product is international
        // or if is NBCU or if is digital delivery recipient (DDELVR)
        if (!isAuthenticated && !isInternational && !skipAddressBookAdd) {
            const getGuestAddressBook = yield select(getGuestAddressBookEntries);

            let filteredAddressBook = [];
            if (getGuestAddressBook && getGuestAddressBook.length > 0) {
                const currentRecipient = getAddressOneLineString(recipientFormDetails);

                filteredAddressBook = getGuestAddressBook.filter((addressObject) => {
                    const addressBookRecipient = getAddressOneLineString(addressObject);
                    return addressBookRecipient === currentRecipient;
                });
            }

            if (filteredAddressBook?.length === 0) {
                const recipientDetails = { ...recipientFormDetails };
                if (recipientFormDetails.country?.length === 3) {
                    const countryObj = getCountryDetailsByThreeDigitCountryCode(recipientFormDetails.country || 'US');
                    recipientDetails.country = countryObj.countryCodeTwoDigit;
                }

                yield put(saveGuestAddressBook(recipientFormDetails));
            }
        }

        if (action.data.closeForm) yield call(action.data.closeForm);

        if (action.data.useAddressForAll && action.data.checkSameAsDeliveryAddress) {
            const configObj = {
                wcEnv: {},
                jwtToken,
                orderItemId: action.data.orderItemId,
                giftMessage: 'No Card Message',
                giftAuthor: '',
                occasionCode: null,
                useThisMessageForAll: 'Y',
                orderId,
            };
            yield call(updateRecipientCart, configObj);
        } else if (action.data.openGiftMessage) {
            yield call(action.data.openGiftMessage);
        }

        yield call(clearFormFields);

        yield call(prepareRetreiveCart, action.data.page);

        yield call(retrieveCart);

        if (action.data.checkSameAsDeliveryAddress) {
            const userProfile = yield select(getProfileInfo);
            if (isAuthenticated) {
                reqObj.recipient.email = userProfile.email;
                reqObj.recipient.confirmEmail = userProfile.email;
            }

            if (recipientFormDetails.country?.length === 3) {
                const countryObj = getCountryDetailsByThreeDigitCountryCode(recipientFormDetails.country || 'US');
                reqObj.recipient.country = countryObj.countryCodeTwoDigit;
            }

            yield put(updateBillingAddressForm(reqObj.recipient));
            yield put(billingAddressIsFormAutoFilled(true));
        }

        // Hide Loader
        yield call(shippingInfoActions.triggerShowShippingInfo);

        yield put(formActions.updatedRecipientAddressSuccessfully());
        yield put(showLoadingMessageActions.flagOffShowLoadingMessage());
    } catch (ex) {
        yield put(callHandleCartFailure(ex));
        ex.orderItemId = action.data.orderItemId;
        yield fork(errorOperations.getError, ex, 'recipientForm');
        yield call(handleProductNotAvailableZipCode);
        yield put(showLoadingMessageActions.flagOffShowLoadingMessage());
    }
}

/*
    Validate Address with QAS before saving address
*/

function* proceedToSaveRecipientAddress(action) {
    const proceedToSave = yield call(qasAddressSearchOperations.workers.validateAddressQAS, action);
    const { allowSave, addressVerifiedStatus } = proceedToSave;
    if (allowSave) {
        const updateVerification = { ...action };
        updateVerification.data.dpvIndicator = addressVerifiedStatus.dpvIndicator;
        updateVerification.data.isAddressVerified = addressVerifiedStatus.isAddressVerified;
        yield call(submitForm, updateVerification);
    }
}

function* extendAddressBookWorker() {
    yield put(showLoadingMessageActions.updateShowLoadingMessage());
    yield take(proccessAddressBookCompleted().type);
    yield put(showLoadingMessageActions.flagOffShowLoadingMessage());
}

function* recipientFormChangeWatcher() {
    yield takeEvery(formActions.updateForm().type, updateForm);
}

function* recipientFormSubmitWatcher() {
    yield takeEvery(formActions.submitForm().type, submitForm);
}

function* addressBookChangeWatcher() {
    yield takeEvery(formActions.handleAddressBookChange().type, updateFormFromAddressBook);
}

function* clearFieldsWatcher() {
    yield takeEvery(formActions.triggerClearRecipientFormFields().type, clearFormFields);
}

// Extend Addressbook Watcher
function* extendAddressBookWatcher() {
    yield takeEvery(loadAddressBookEntry().type, extendAddressBookWorker);
}

function* proceedToSaveWatcher() {
    yield takeEvery(formActions.proceedToSave().type, proceedToSaveRecipientAddress);
}

/* PWA Desktop Code Start */
function* pwaDesktopSubmitForm(action) {
    try {
        // Show Site Loader
        yield put(showLoadingMessageActions.updateShowLoadingMessage());
        // Clear Error
        yield put(errorActions.clearErrors({
            errType: 'recipientForm',
            field: `${action.data.orderItemId}_productNotAvailable`,
        }));
        yield put(errorActions.clearErrors({
            errType: 'recipientFormClearAllFields',
            field: 'error',
        }));
        yield put(errorActions.clearErrors({
            errType: 'payment',
            field: action.data.orderItemId,
        }));
        yield put(errorActions.clearErrors({
            errType: 'validateBillingAddress',
        }));

        yield put(errorActions.clearErrors({
            errType: 'payment',
            field: 'orderItemError',
        }));

        // Recipient Form Data
        const recipientFormDetails = action.data.recipient;
        const entryId = action.data.recipient?.entryId || '';

        const isAuthenticated = yield select(getIsAuthenticatedStatus);
        const isInternational = yield call(checkIfSavingInternationalProduct, recipientFormDetails);

        if (action.data.useAddressForAll) {
            recipientFormDetails.useAddressForAll = 'Y';
        }

        if (action.data.isAddressVerified) recipientFormDetails.isAddressVerified = action.data.isAddressVerified;
        if (action.data.dpvIndicator) recipientFormDetails.dpvIndicator = action.data.dpvIndicator;

        const editingRecipient = yield select(commonSelectors.getCart); // getting current saved recipient address
        const orderItemEditing = editingRecipient?.[0]?.cartItems?.[0] || {};
        const skipAddressBookAdd = ['NBCU', 'DDELVR'].includes(orderItemEditing?.itemInfo?.lineItemType);

        if (skipAddressBookAdd) {
            recipientFormDetails.skipAddressBookAdd = skipAddressBookAdd;
        }

        const jwtToken = yield call(checkJWT);
        const orderId = yield select(commonSelectors.getOrderId);
        const reqObj = {
            wcEnv: {},
            jwtToken,
            orderItemId: action.data.orderItemId,
            recipient: recipientFormDetails,
            entryId,
            orderId,
        };
        // Save Recipient Address
        yield call(addRecipient, reqObj);

        // Avoid saving recipient address to guest address book if product is international
        // or if is NBCU or digital delivery Recipient (DDELVR)
        if (!isAuthenticated && !isInternational && !skipAddressBookAdd) {
            const getGuestAddressBook = yield select(getGuestAddressBookEntries);

            let filteredAddressBook = [];
            if (getGuestAddressBook && getGuestAddressBook.length > 0) {
                const currentRecipient = getAddressOneLineString(recipientFormDetails);

                filteredAddressBook = getGuestAddressBook.filter((addressObject) => {
                    const addressBookRecipient = getAddressOneLineString(addressObject);
                    return addressBookRecipient === currentRecipient;
                });
            }

            if (filteredAddressBook?.length === 0) {
                const recipientDetails = { ...recipientFormDetails };
                if (recipientFormDetails.country?.length === 3) {
                    const countryObj = getCountryDetailsByThreeDigitCountryCode(recipientFormDetails.country || 'US');
                    recipientDetails.country = countryObj.countryCodeTwoDigit;
                }
                if (recipientFormDetails.phoneNumber) {
                    recipientDetails.phone = recipientFormDetails.phoneNumber;
                }

                recipientFormDetails.firstAndLastName = `${recipientFormDetails.firstName} ${recipientFormDetails.lastName}`;
                yield put(saveGuestAddressBook(recipientFormDetails));
            }
        }

        yield call(clearFormFields);

        if (action.data.checkSameAsDeliveryAddress) {
            const userProfile = yield select(getProfileInfo);

            if (isAuthenticated) {
                reqObj.recipient.email = userProfile.email;
                reqObj.recipient.confirmEmail = userProfile.email;
                reqObj.recipient.checkSameAsDeliveryAddress = true;
            }

            if (recipientFormDetails.country?.length === 3) {
                const countryObj = getCountryDetailsByThreeDigitCountryCode(recipientFormDetails.country || 'US');
                reqObj.recipient.country = countryObj.countryCodeTwoDigit;
            }

            yield put(updateBillingAddressForm(reqObj.recipient));
            yield put(billingAddressIsFormAutoFilled(true));
            yield put(billingAddressCheckSameAsDeliveryAddress(true));
        }
        yield call(shippingInfoActions.triggerShowShippingInfo);
        yield put(formActions.updatedRecipientAddressSuccessfully());
        yield put(showLoadingMessageActions.flagOffShowLoadingMessage());
    } catch (ex) {
        yield put(callHandleCartFailure(ex));
        ex.orderItemId = action.data.orderItemId;
        yield fork(errorOperations.getError, ex, 'recipientForm');
        yield call(handleProductNotAvailableZipCode);
        yield put(showLoadingMessageActions.flagOffShowLoadingMessage());
        throw ex;
    }
}

function prepareRecipientFormData(recipientFormData, isFullname = false) {
    const recipientObject = {
        entryId: recipientFormData?.entryId || '',
        firstName: recipientFormData.firstName,
        lastName: recipientFormData.lastName,
        address1: recipientFormData.address1,
        address2: recipientFormData.address2,
        locationType: recipientFormData.locationType,
        nameOfLocation: recipientFormData.nameOfLocation,
        state: recipientFormData.state,
        country: recipientFormData.country,
        zipCode: getFormattedZipCode(recipientFormData.zipCode),
        phone: removeMaskForPhoneNumber(recipientFormData.phone),
        city: recipientFormData.city,
        email: recipientFormData.email,
        organizationName: recipientFormData.organizationName,
        funeralServiceTime: recipientFormData.funeralServiceTime,
    };

    if (recipientFormData.firstAndLastName && isFullname) {
        const firstAndLastNameValue = (recipientFormData.firstAndLastName).trim().split(' ');
        recipientObject.firstName = recipientFormData.firstAndLastName;
        recipientObject.lastName = '';

        if (firstAndLastNameValue.length >= 6) {
            recipientObject.firstName = `${firstAndLastNameValue[0]} ${firstAndLastNameValue[1]} ${firstAndLastNameValue[2]}`;
            recipientObject.lastName = `${firstAndLastNameValue[3]} ${firstAndLastNameValue[4]} ${firstAndLastNameValue[5]}`;
        } else if (firstAndLastNameValue.length === 5) {
            recipientObject.firstName = `${firstAndLastNameValue[0]} ${firstAndLastNameValue[1]} ${firstAndLastNameValue[2]}`;
            recipientObject.lastName = `${firstAndLastNameValue[3]} ${firstAndLastNameValue[4]}`;
        } else if (firstAndLastNameValue.length === 4) {
            recipientObject.firstName = `${firstAndLastNameValue[0]} ${firstAndLastNameValue[1]}`;
            recipientObject.lastName = `${firstAndLastNameValue[2]} ${firstAndLastNameValue[3]}`;
        } else if (firstAndLastNameValue.length === 3) {
            recipientObject.firstName = `${firstAndLastNameValue[0]} ${firstAndLastNameValue[1]}`;
            recipientObject.lastName = firstAndLastNameValue[2];
        } else if (firstAndLastNameValue.length >= 2) {
            recipientObject.firstName = firstAndLastNameValue[0];
            recipientObject.lastName = firstAndLastNameValue[1];
        }
    }

    return recipientObject;
}

function* prepartRecipientCartSympathy(recipientFormData) {
    const addressSource = yield select(getAddressSource);
    const { funeralServiceTime } = recipientFormData;

    if (funeralServiceTime && typeof funeralServiceTime === 'string' && funeralServiceTime.includes('-')) {
        const [viewStartTime, viewEndTime] = funeralServiceTime.split(' - ');
        return {
            sympathySource: addressSource === 'SCI' ? addressSource : 'OTHER',
            viewStartTime,
            viewEndTime,
        };
    }

    if (funeralServiceTime && typeof funeralServiceTime === 'string' && addressSource === 'SCI') {
        return {
            sympathySource: addressSource,
            viewStartTime: funeralServiceTime,
            viewEndTime: '',
        };
    }

    if (funeralServiceTime && typeof funeralServiceTime === 'string') {
        return {
            sympathySource: 'OTHER',
            viewStartTime: funeralServiceTime,
            viewEndTime: '',
        };
    }

    return null;
}

const capitalizeCity = (city) => city?.toLowerCase().replace(/(?:^|\s)\S/g, (a) => a.toUpperCase());

const getCity = (cityList, selectCity) => {
    if (selectCity && cityList?.find((city) => city.toLowerCase() === selectCity.toLowerCase())) {
        return capitalizeCity(cityList.find((city) => city.toLowerCase() === selectCity.toLowerCase()) || '');
    }
    return capitalizeCity(cityList?.[0] || selectCity || '');
};

function* triggerStateCityData(action) {
    try {
        let formZipCode = action.data.trim();
        let labelZip = 'Zip Code';
        let checkZip = false;

        if ((formZipCode.length === 6 || formZipCode.length === 7) && isCandaZip(formZipCode)) {
            checkZip = true;
            const zipSplit = formZipCode.replace(/\s/gi, '').toUpperCase().split('');
            zipSplit.splice(3, 0, ' ');
            formZipCode = zipSplit.join('');
            labelZip = 'Postal Code';
        } else if (formZipCode.length >= 5) { // This is important for checkout, zipcode from the API returns without the zipcode extension (60015-5253) -  60015 is used for saving the zipcode
            checkZip = true;
        }

        const jwtToken = yield call(checkJWT);
        const reqObj = {
            jwtToken,
            zipCode: formZipCode,
        };

        yield put(errorActions.loadError({ errType: 'recipientForm', errMsg: { zipCode: '' } }));

        if (reqObj && reqObj.zipCode && checkZip) {
            const resStateCityData = yield call(getStateCityData, reqObj);
            const cityStateDate = resStateCityData.data.esbSaltaServiceResponse;

            if (cityStateDate && cityStateDate.checkZipResponse
                && cityStateDate.checkZipResponse.checkZipResult
                && cityStateDate.checkZipResponse.checkZipResult.flwsErrors) {
                yield put(errorActions.loadError({ errType: 'recipientForm', errMsg: { zipCode: `${'Invalid '}${labelZip}` } }));
            }

            if (cityStateDate && cityStateDate.checkZipResponse
                && cityStateDate.checkZipResponse.checkZipResult
                && cityStateDate.checkZipResponse.checkZipResult.location
                && cityStateDate.checkZipResponse.checkZipResult.location.state) {
                const {
                    checkZipResponse: {
                        checkZipResult: {
                            location: {
                                state,
                                country,
                                cityList: {
                                    city,
                                },
                                zipCode,
                            },
                        },
                    },
                } = cityStateDate;
                const cityList = [
                    ...new Set(city),
                ];

                yield put(errorActions.loadError({ errType: 'recipientForm', errMsg: { zipCode: '' } }));

                const [editingRecipient] = yield select(commonSelectors.getCart); // getting current saved recipient address
                const currentCity = editingRecipient?.recipientAddress?.city || null; // if user saved address then use previous city
                const recipientAddressForm = yield select(commonSelectors.getRecipientForm); // getting current form values
                const cityFromList = getCity(cityList, recipientAddressForm?.city || currentCity);

                if (country === 'CAN' || country === 'USA') {
                    yield put(formActions.updateRecipientForm({
                        country: country.slice(0, -1),
                        state,
                        cityArray: cityList,
                        city: cityFromList,
                        zipCode,
                    }));
                } else {
                    yield put(formActions.updateRecipientForm({
                        state,
                        cityArray: cityList,
                        city: cityFromList,
                        zipCode,
                    }));
                }
            }
        }
    } catch (ex) {
        mbpLogger.logError({
            appName: process.env.npm_package_name,
            module: 'RecipientForm-Operations.js',
            function: 'triggerStateCityData',
            jsError: ex,
        });
    }
}

function* workerViewFuneralServiceTime(action) {
    try {
        const jwtToken = yield call(checkJWT);
        const cartId = yield select(getOrderId);
        const {
            orderItemId: cartItemId, promisedAvailableTime, zipCode, state, country,
        } = action.data;
        let deliveryDate = null;
        const currentDate = promisedAvailableTime ? new Date(promisedAvailableTime) : null;

        if (currentDate) {
            const currentDay = (`0${currentDate.getDate()}`).slice(-2);
            const currentMonth = (`0${currentDate.getMonth() + 1}`).slice(-2);
            deliveryDate = currentDate ? `${currentDate.getFullYear()}-${currentMonth}-${currentDay}` : null;
        }
        const payload = {
            env: {},
            jwtToken,
            cartId,
            cartItemId,
            deliveryDate,
            zipCode,
            state,
            country,
        };
        const viewTimeResponse = yield call(cartServiceClient.displayViewTime, payload);
        const { viewTime } = viewTimeResponse.data;

        yield put(formActions.updateRecipientForm({
            viewTime,
        }));
    } catch (ex) {
        yield put(formActions.updateRecipientForm({
            viewTime: '',
        }));
        mbpLogger.logError({
            module: 'RecipientForm-Operations.js',
            function: 'triggerGetViewTime',
            jsError: ex,
        });
    }
}

function* workerDeleteFuneralServiceTime(action) {
    try {
        const jwtToken = yield call(checkJWT);
        const cartId = yield select(getOrderId);
        const { cartItemId } = action.data;

        yield call(cartServiceClient.deleteViewTime, {
            env: {}, jwtToken, cartId, cartItemId,
        });
        yield put(formActions.updateRecipientForm({ funeralServiceTime: '' }));
        yield call(retrieveCart);
    } catch (ex) {
        mbpLogger.logError({
            module: 'RecipientForm-Operations.js',
            function: 'triggerDeleteViewTime',
            jsError: ex,
        });
    }
}

function* loadRecipientDetails() {
    try {
        const [editingRecipient] = yield select(commonSelectors.getCart);
        if (editingRecipient?.recipientAddress) {
            const recipientDetails = editingRecipient.recipientAddress;
            const [cartItems] = editingRecipient?.cartItems || [];
            const isInternational = yield call(checkIsInternational, cartItems);

            // load recipient address for for the next item
            const fillRecipientDetails = yield call(recipientFormFields, recipientDetails, cartItems);

            // load gift message for the next item
            if (editingRecipient?.cartItems?.length > 0 && editingRecipient.cartItems[0]?.greetingMessage?.greetingMessage) {
                const giftMessageData = editingRecipient.cartItems[0].greetingMessage.greetingMessage;
                const giftAuthorData = editingRecipient.cartItems[0].greetingMessage.signature || '';
                yield call(formatFullGifMessage, giftMessageData, giftAuthorData);
            }

            // set fields values for internation products
            if (isInternational) {
                const countryField = yield call(getInternationalCountryField, cartItems);
                fillRecipientDetails.country = countryField;
                fillRecipientDetails.state = 'OS';
                fillRecipientDetails.zipCode = '00000';
            } else {
                fillRecipientDetails.country = yield call(getCountryField, recipientDetails?.country);
            }

            if (recipientDetails?.firstName) {
                const { firstName, lastName, phoneNumber } = recipientDetails;
                if (firstName && lastName && phoneNumber) {
                    fillRecipientDetails.isFormValid = true;
                } else {
                    fillRecipientDetails.isFormValid = false;
                }
                yield put(formActions.updateFormAddressFromPreFill(fillRecipientDetails));
            } else {
                fillRecipientDetails.isFormValid = false;
                yield put(formActions.updateFormAddressFromPreFill(fillRecipientDetails));
            }

            // Load CityList and State from Zipcode
            if (recipientDetails?.zipCode && !isInternational) {
                yield put(formActions.triggerStateCityData(recipientDetails.zipCode));
            }

            // the current edit recipient is not working in redux anymore.
            // if (cIEnabled) {
            //     // Review the product has card isle available.
            //     yield call(loadCardIsleAvailable);
            // }
        }

        yield put(showLoadingMessageActions.flagOffShowLoadingMessage());

        if (typeof window !== 'undefined') {
            window.scrollTo(0, 0);
        }
    } catch (ex) {
        mbpLogger.logError({
            appName: process.env.npm_package_name,
            module: 'RecipientForm-Operations.js',
            function: 'loadRecipientDetails',
            jsError: ex,
        });
    }
}

function* submitRecipientForm(action) {
    try {
        // Show Site Loader
        yield put(showLoadingMessageActions.updateShowLoadingMessage());

        const {
            orderItemId, history, dpvIndicator, isAddressVerified,
            checkSameAsDeliveryAddress, orderGreetingId,
        } = action.data;
        const objRecipientFormData = yield select(commonSelectors.getRecipientForm);
        const flagState = yield select(getFeatureFlags);

        const isMinifiedShippingEnabled = flagState['is-minified-shipping-enabled'] || false;

        const objPrepareRecipientFormData = yield call(prepareRecipientFormData, objRecipientFormData, isMinifiedShippingEnabled);
        const sympathy = yield call(prepartRecipientCartSympathy, objRecipientFormData);
        const actionDataSaveRecipient = {
            data: {
                orderItemId,
                recipient: objPrepareRecipientFormData,
                checkSameAsDeliveryAddress,
                useAddressForAll: false,
                dpvIndicator,
                isAddressVerified,
                page: 'shipping',
                avoidClearForm: false,
            },
        };

        // Save Recipient Address Saga
        yield call(pwaDesktopSubmitForm, actionDataSaveRecipient);

        // Add Greeting Card
        // Review if the card is enabled and filled
        let typeGreeting = 'message';
        const cardSelected = yield select(getCardIsleSelected);
        const cIEnabled = flagState['is-card-isle-enabled'] || false;
        if (cIEnabled && cardSelected?.pickupCode) {
            typeGreeting = 'card';
        }

        if (typeGreeting === 'message') {
            // Save gift message
            let payloadGiftMessage = 'No Card Message';
            const giftMessageObj = yield select(giftMessageFormSelectors.getGiftMessageField);
            /*
            * Regex (/\n/g, '|') is used to replace new line with Charater |
            * eg Good Morning \n Have a great day \n thank you to "Good Morning | Have a great day | thank you "
            */
            const messageTextPiped = giftMessageObj.message.replace(/\n/g, '|');

            if (messageTextPiped.replace('|', '').trim().length > 0) {
                payloadGiftMessage = messageTextPiped;
            }

            const occasionCode = giftMessageObj?.occasion || '';
            const actionDataSaveGiftMessage = {
                data: {
                    orderItemId,
                    giftMessage: payloadGiftMessage,
                    giftAuthor: giftMessageObj.author,
                    occasionCode,
                    sympathy,
                    orderGreetingId,
                },
            };

            // Save Gift Message Saga
            yield call(pwaDesktopAddGiftMessage, actionDataSaveGiftMessage);
        } else {
            // Save Card isle
            yield call(addCardIsleToCart, orderItemId, objRecipientFormData);

            if (sympathy) {
                const jwtToken = yield call(checkJWT);
                const orderId = yield select(getOrderId);
                const configObj = {
                    wcEnv: {},
                    jwtToken,
                    orderItemId,
                    orderId,
                    sympathy,
                };

                yield call(updateFuneralTime, configObj);
            }
        }

        if (cIEnabled) {
            yield put(resetCardIsle());
        }
        yield put(resetGiftMessageForm());

        // Get Cart
        yield call(retrieveCart);

        const recipientEditingIndex = yield select(commonSelectors.getWorkingRecipient);
        const orderItemCount = yield select(commonSelectors.getNoOfOrderItems);

        if (recipientEditingIndex < orderItemCount - 1) {
            yield put(updateWorkingRecipient());
            yield call(loadRecipientDetails);
        } else {
            yield put(triggerValidateOrder(history));
            const cartValidated = yield take(triggerValidateOrderCompleted().type);

            if (!cartValidated?.status) {
                yield call(loadRecipientDetails);
            } else {
                yield put(setSkipValidateCart(true));
            }
            yield put(showLoadingMessageActions.flagOffShowLoadingMessage());
        }
    } catch (ex) {
        yield put(showLoadingMessageActions.flagOffShowLoadingMessage());
        mbpLogger.logError({
            appName: process.env.npm_package_name,
            module: 'RecipientForm-Operations.js',
            function: 'submitRecipientForm',
            jsError: ex,
        });
    }
}

function* proceedSaveRecipientPwaDesktop(action) {
    const proceedToSave = yield call(qasAddressSearchOperations.workers.validateAddressQAS, action);
    const { allowSave, addressVerifiedStatus } = proceedToSave;

    if (allowSave) {
        const updateVerification = { ...action };
        updateVerification.data.dpvIndicator = addressVerifiedStatus.dpvIndicator;
        updateVerification.data.isAddressVerified = addressVerifiedStatus.isAddressVerified;

        yield call(submitRecipientForm, updateVerification);
    }
}

function* watcherSubmitRecipientPWADesktop() {
    yield takeLatest(formActions.submitRecipientPwaDesktop().type, submitRecipientForm);
}

function* watcherSaveRecipientPWADesktop() {
    yield takeLatest(formActions.proceedSaveRecipientPwaDesktop().type, proceedSaveRecipientPwaDesktop);
}

function* watcherTriggerStateCityData() {
    yield takeLatest(formActions.triggerStateCityData().type, triggerStateCityData);
}

function* watcherViewFuneralServiceTime() {
    yield takeLatest(formActions.triggerGetViewTime().type, workerViewFuneralServiceTime);
}

function* watcherDeleteFuneralServiceTime() {
    yield takeLatest(formActions.triggerDeleteViewTime().type, workerDeleteFuneralServiceTime);
}

/* PWA Desktop Code End */

const watchers = [
    fork(recipientFormSubmitWatcher),
    fork(recipientFormChangeWatcher),
    fork(addressBookChangeWatcher),
    fork(clearFieldsWatcher),
    fork(extendAddressBookWatcher),
    fork(proceedToSaveWatcher),
    fork(watcherSubmitRecipientPWADesktop),
    fork(watcherSaveRecipientPWADesktop),
    fork(watcherTriggerStateCityData),
    fork(watcherViewFuneralServiceTime),
    fork(watcherDeleteFuneralServiceTime),
];

export { watchers, addRecipient };

export default {};
